import React from 'react';

/**
 * Riga di filtro a chip cliccabili. Estratta da Collections.jsx, dove viveva
 * come componente locale non esportato. `items` è un array di stringhe
 * semplici (shade/materials/colors) salvo dove il chiamante passa `normalize`
 * per un confronto diverso dall'uguaglianza diretta (es. category, che
 * confronta in maiuscolo — non usato da questa pagina). `display` mostra
 * un'etichetta diversa dal valore (in inglese il valore resta quello del feed).
 */
export const FacetRow = ({ label, items, active, onPick, testid, normalize, display }) => {
  if (!items?.length) return null;
  return (
    <div className="grid gap-3 md:grid-cols-[110px_1fr] md:items-baseline">
      <p className="text-[14px] font-bold text-inchiostro/70">{label}</p>
      <div className="flex flex-wrap gap-2">
        {items.map((v) => {
          const on = normalize ? normalize(v) : active === v;
          return (
            <button
              key={v}
              type="button"
              onClick={() => onPick(v)}
              data-testid={`${testid}-${String(v).toLowerCase().replace(/\s+/g, '-')}`}
              className={`px-3 py-1.5 text-[14px] font-semibold transition-colors ${
                on
                  ? 'bg-marsala text-carta'
                  : 'border border-inchiostro/16 hover:border-inchiostro hover:bg-inchiostro hover:text-carta'
              }`}
            >
              {display ? display(v) : v}
            </button>
          );
        })}
      </div>
    </div>
  );
};
